export const types = {
  NOTIFICATIONS: 'notifications',
  NOTIFICATION_REQUESTS: 'notificationRequests'
};
